<template>
    <div>
        <b-breadcrumb :items="items" />
        <div class="container-fluid" style="background-color: white">
            <br>
            <div class="text-center">
                <h2>บันทึกการฝาก-เบิก</h2>
            </div>
            <br/>
            <div class="row" style="margin-left: 30px" >
                <div class="col-sm-6">
                    <span><b>ชื่อ</b> : {{driver.first_name}}</span>
                    <br/><br/>
                    <span><b>นามสกุล</b> : {{driver.last_name}}</span>
                    <br/><br/>
                    <span>
                    <b>เบอร์โทรศัพท์</b> :
                    <span>{{driver.phone}} </span>
                </span>
                </div>
                <div class="col-sm-6">
                    <span><b>ทะเบียนรถ</b> : {{driver.license_plate}}</span>
                    <br/><br/>
                    <span><b>จำนวนคงเหลือ</b> : {{driver.deposit_total | currency }}</span>
                </div>
            </div>
            <br>
            <div class="row inline-block justify-content-end">
                <div>
                    <date-picker
                        v-model="date"
                        type="date"
                        format="DD/MM/YYYY"
                        :lang="lang"
                        class="w-100"
                        range
                        confirm
                        @change="getSearch"
                        placeholder="เลือกวันที่" >
                    </date-picker>
                </div>
                &nbsp;&nbsp;
                <div>
                    <button type="button" class="btn btn-outline-danger" @click="printTransactionModal">
                        <icon name="pencil-alt"></icon>
                        รายงาน ฝาก-เบิก
                    </button>
                </div>
                &nbsp;&nbsp;
                <div>
                    <button type="button" class="btn btn-outline-danger" @click="showTransactionModal">
                        <icon name="pencil-alt"></icon>
                        เพิ่ม/ลบ เงินฝาก
                    </button>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;
            </div>

            <div class="col-12 table-responsive">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">วัน/เดือน/ปี ที่จ่าย</th>
                        <th scope="col">ลูกค้า</th>
                        <th scope="col">TN</th>
                        <th scope="col">จำนวนฝาก</th>
                        <th scope="col">จำนวนถอน</th>
                        <th scope="col">จำนวนคงเหลือ</th>
                        <th scope="col">ผู้ชำระ</th>
                        <th scope="col">ผู้รับเงิน</th>
                        <th scope="col" v-if="canViewSuperAdmin">แก้ไขรายการ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in depositTable">
                        <td>{{data.date | moment("DD/MM/YYYY") }}</td>
                        <td>
                            <template v-for="customer in data.customers">
                                <div>-{{customer.customer_id}} {{customer.store_name}}</div>
                            </template>
                            <template v-if="data.reason">
                                {{data.reason}}
                            </template>
                        </td>
                        <td class="text-left">
                            <template v-if="data.driver_details && data.driver_details.driver_details_invoices">
                                <span v-for="(tn,i) in data.driver_details.driver_details_invoices">
                                    <span v-if="i > 0"><br/></span>{{tn.invoice.invoice_id}}
                                    <span v-if="tn.invoice.customer&&!tn.invoice.customer_other&&tn.invoice.customer.store_name"> {{tn.invoice.customer&&tn.invoice.customer.store_name?tn.invoice.customer.store_name:tn.invoice.customer.name}}</span>
                                    <span v-else-if="tn.invoice.customer&&tn.invoice.customer_other&&tn.invoice.customer_other.store_name"> {{tn.invoice.customer&&tn.invoice.customer.store_name?tn.invoice.customer.store_name:tn.invoice.customer.name}}</span>
                                </span>
                            </template>
                            <template v-else>
                                -
                            </template>
                        </td>
                        <td>
                            <template v-if="data.deposit > 0">
                            <span style="color: green">
                                + {{data.deposit | currency }}
                            </span>
                            </template>
                            <template v-else>
                                -
                            </template>
                        </td>
                        <td>
                            <template v-if="data.withdraw > 0">
                            <span style="color: red">
                                - {{data.withdraw | currency }}
                            </span>
                            </template>
                            <template v-else>
                                -
                            </template>

                        </td>
                        <td>{{data.balance | currency }}</td>
                        <td>{{driver.name}}</td>
                        <td>{{data.recipient}}</td>
                        <td v-if="canViewSuperAdmin">
                            <a @click="showEditDepositListModal(data)">
                                <icon name="pencil-alt"></icon>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <div v-if="depositTable.length > 0">
                    <vue-pagination :pagination="dataPaginate"
                                    @paginate="getPage">
                    </vue-pagination>
                </div>
            </div>
            <b-modal hide-header hide-footer ref="transaction">
                <div>
                    <h3 style="text-align: center">แก้ไขบัญชีเงินฝาก</h3>
                    <div class="row form-group">
                        <div class="col-5 text-right">ฝากเงิน (+)</div>
                        <div class="col-6">
                            <input type="number" class="form-control" v-model="edit_data.deposit"/>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-5 text-right">ถอนเงิน (-)</div>
                        <div class="col-6">
                            <input type="number" class="form-control" v-model="edit_data.withdraw"/>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-5 text-right">เหตุผลการแก้ไข <span style="color: red">*</span></div>
                        <div class="col-6">
                            <textarea class="form-control"
                                      style="min-height: 100px"
                                      v-model="edit_data.reason"
                                      placeholder="แก้ไขรายการฝากเงินวันที่ 01/01/2020"></textarea>
                        </div>
                    </div>
                    <div class="col text-center">
                        <button class="btn btn-success" type="button" @click="saveTransaction">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก
                        </button>&nbsp;&nbsp;
                        <button class="btn btn-secondary" type="button" @click="hideTransactionModal">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </button>
                    </div>
                </div>
            </b-modal>
            <b-modal hide-header hide-footer ref="edit_deposit_list">
                <div class="row form-group">
                    <div class="col-4 text-right">
                        <label>รายการ</label>
                    </div>
                    <div class="col-6 text-right">
                        <input type="text" class="form-control" v-model="edit_list.reason"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-4 text-right">
                        <label>จำนวนฝาก</label>
                    </div>
                    <div class="col-6 text-right">
                        <input type="text" class="form-control" v-model="edit_list.deposit" disabled/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-4 text-right">
                        <label>จำนวนถอน</label>
                    </div>
                    <div class="col-6 text-right">
                        <input type="text" class="form-control" v-model="edit_list.withdraw" disabled/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-4 text-right">
                        <label>จำนวนคงเหลือ</label>
                    </div>
                    <div class="col-6 text-right">
                        <input type="text" class="form-control" v-model="edit_list.balance" disabled/>
                    </div>
                </div>
                <div class="col text-center">
                    <button class="btn btn-success" type="button" @click="editDataList">
                        <icon name="save" style="width: 25px"></icon>
                        บันทึก
                    </button>&nbsp;&nbsp;
                    <button class="btn btn-secondary" type="button" @click="hideEditDepositListModal">
                        <icon name="times" style="width: 25px"></icon>
                        ยกเลิก
                    </button>
                </div>
            </b-modal>
            <!--<pre class="alert alert-primary">{{ driver }}</pre>-->
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import DeleteConfirmModal from "../../Utility/DeleteConfirmModal";
    import VuePagination from "../../Pagination";
    import moment from 'moment';
    import DatePicker from 'vue2-datepicker'
    import {
        canViewSuperAdmin
    }
    from "../../../util/Permissions";
    import {domain} from "../../../util/Constants";

    export default {
        components: {
            VuePagination,
            DeleteConfirmModal,
            DatePicker},
        name: "deposit-information",
        data(){
          return {
              delete_id : null,
              edit_data :{
                deposit : '',
                withdraw : '',
                reason : '',
              },
              edit_list:{
                  id : '',
                  reason : '',
                  deposit : '',
                  withdraw : '',
                  balance : '',
              },
              date : [],
              lang: {
                  days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                  months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                  pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                  placeholder: {
                      date: 'วว/ดด/ปปปป',
                  }
              },
              items: [
                  {
                      text: "บันทึกเงินฝาก",
                      to: { name: "deposit" }
                  },
                  {
                      text: "เพิ่มเติม",
                      active: true
                  }
              ],
          }
        },
        created(){

        },
        computed:{
            canViewSuperAdmin,
            ...mapState({
                driver :state=>{
                    return state.Driver.form;
                },
                depositTable:state=>{
                    return state.Deposit.deposit
                },
                dataPaginate:state=>{
                    return state.Deposit.dataPaginate
                },
                user:state=>{
                    return state.Auth.user
                },
            })
        },
        methods:{
            getSearch(){
                if(this.date[0] && this.date[1]){
                    let data = {
                        id: this.driver.id,
                        date_start: moment(this.date[0]).format("YYYY-MM-DD"),
                        date_end: moment(this.date[1]).format("YYYY-MM-DD"),
                        page: this.dataPaginate.current_page,
                    };
                    this.$store.dispatch("Deposit/searchDetail",data)
                }
            },
            printTransactionModal(){
                let data = {
                    id: this.driver.id,
                    date_start: this.date[0]?moment(this.date[0]).format("YYYY-MM-DD"):'',
                    date_end: this.date[1]?moment(this.date[1]).format("YYYY-MM-DD"):'',
                    excel: 'excel',
                };
                window.open(`${domain}/deposit_details_search?id=${data.id}&date_start=${data.date_start}&date_end=${data.date_end}&excel=${data.excel}`);
            },
            showTransactionModal(){
                this.$refs.transaction.show();
            },
            hideTransactionModal(){
                this.$refs.transaction.hide();
            },
            showEditDepositListModal(data){
                this.edit_list.id = data.id
                this.edit_list.withdraw = data.withdraw ? data.withdraw : 0
                this.edit_list.deposit = data.deposit ? data.deposit : 0
                this.edit_list.balance = data.balance
                this.edit_list.reason = data.reason
                this.$refs.edit_deposit_list.show();
            },
            hideEditDepositListModal(){
                this.edit_list = {
                    id : '',
                    reason : '',
                    deposit : '',
                    withdraw : '',
                    balance : '',
                };
                this.$refs.edit_deposit_list.hide();
            },
            deleteData(value){
                this.hideDeleteModal();
            },
            getPage(){
                this.$store.dispatch("Deposit/showDepositTable",{
                    driver_id : this.driver.id,
                    page : this.dataPaginate.current_page,
                })
            },
            saveTransaction(){
                if(this.edit_data.deposit && this.edit_data.withdraw){
                    alert("กรุณาเลือกกรอกจำนวนเงินอย่างใดอย่างหนึ่ง");
                }else if(!this.edit_data.deposit && !this.edit_data.withdraw){
                    alert("กรุณาเลือกกรอกจำนวนเงินอย่างใดอย่างหนึ่ง");
                }else if(!this.edit_data.reason){
                    alert("กรุณากรอกเหตุผลที่ต้องการแก้ไข");
                }else{
                    let data = {
                        driver_id : this.driver.id,
                        deposit : this.edit_data.deposit,
                        withdraw: this.edit_data.withdraw,
                        date : moment().format("YYYY-MM-DD"),
                        recipient : this.user.name,
                        reason : this.edit_data.reason,
                    };
                    this.$store.dispatch("Deposit/save",data).then(()=>{
                        alert("บันทึกสำเร็จ");
                        this.hideTransactionModal();
                        this.edit_data = {
                            deposit : '',
                            withdraw : '',
                            reason : '',
                        };
                        this.$store.dispatch("Deposit/showDepositTable",{
                            driver_id : this.driver.id,
                            page : 1,
                        })
                    }).catch(err=>{
                        alert("บันทึกไม่สำเร็จ")
                    })
                }
            },
            editDataList(){
                this.$store.dispatch("Deposit/updateDeposit",{
                    id : this.edit_list.id,
                    data : this.edit_list,
                }).then(()=>{
                    alert('บันทึกสำเร็จ')
                    this.getPage();
                }).catch(()=>{
                    alert('บันทึกไม่สำเร็จ')
                })
                this.hideEditDepositListModal();
            }
        }
    }
</script>

<style scoped>
    thead{
        background-color: lightgray;
        color: black;
    }
    tbody{
        background-color: white;
        color: black;
    }
</style>
